import { render, staticRenderFns } from "./xqxstj.vue?vue&type=template&id=deb211ec&"
import script from "./xqxstj.vue?vue&type=script&lang=js&"
export * from "./xqxstj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports